import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperDirective } from '@usheru-hff/shared/ui-swiper';
import { SwiperOptions } from 'swiper/types';
import { MovieLaurel } from '@usheru-hff/shared/domain';
import { UiMovieLaurelComponent } from '@usheru-hff/movie-detail/ui-movie-laurel';

@Component({
  selector: 'ush-feature-laurels-carousel',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, SwiperDirective, UiMovieLaurelComponent],
  templateUrl: './feature-laurels-carousel.component.html',
  styleUrl: './feature-laurels-carousel.component.scss'
})
export class FeatureLaurelsCarouselComponent implements OnInit {
  swiperConfig: SwiperOptions;

  @Input() laurels: MovieLaurel[] = [];

  ngOnInit(): void {
    this.swiperConfig = {
      slidesPerView: 1.4,
      spaceBetween: 10,
      scrollbar: true,
      breakpoints: {
        480: {
          slidesPerView: 2.4,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    };
  }
}
